/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".ag-floating-bottom .ag-row-hover .renderer-pinned-container{background-color:#ccc}.renderer-pinned-container[_ngcontent-%COMP%]{font-size:13px;background-color:#959595}.renderer-pinned-default[_ngcontent-%COMP%]{text-overflow:ellipsis;display:block;overflow:hidden}.lfwms-checkbox[_ngcontent-%COMP%]{font-size:15px;color:#fff;padding-left:2px;padding-top:7px}  .ag-floating-bottom .ag-row-hover .lfwms-checkbox{color:#959595}.fa-disabled[_ngcontent-%COMP%]{opacity:.6;cursor:not-allowed}"];
export { styles as styles };

